import { Button } from 'primereact/button'
import React, { useContext } from 'react'
import { MenuLinkProps } from '../../types/common'
import { useNavigate } from 'react-router-dom'
import { CommonContext } from "./context/commonContext";
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const MenuLink = ( props: MenuLinkProps ) => {
    const { $toast, $http } = useContext(CommonContext)
    const { t } = useTranslation();
    const navigate = useNavigate()
    const onClickMove = async( uri: string ) => {

        const uriFilter = [
            '/inbound',
            '/outbound',
            '/inventory-list',
            '/inventory-supplement',
            '/location-regist',
        ]
        if (uriFilter.includes(uri)) {
            const result = await findInventorySurveyCheck()

            if (result) {
                $toast({ title: t(tokens.common.fail), text: '재고조사 중에는 재고의 입・출고 및 조정이 불가합니다.', icon: 'warn' })
                return
            }
        }
        navigate(uri)
    }


    const findInventorySurveyCheck = async () => {
        return await $http().get('/inventory-survey/check')

    }

    return (
        <div className="grid justify-content-center">
            {props &&
                props.items.map(( item ) => (
                    <div className="col-12 flex" key={item.name}>
                        <Button
                            label={item.name}
                            size="large"
                            className={`font-bold text-4xl w-full mx-4 ${props.color ? props.color : 'bg-color-secondary border-color-secondary'}`}
                            onClick={() => onClickMove(item.uri)}
                        />
                    </div>
                ))}
        </div>
    )
}

export default MenuLink
